import { SectionGap, SectionStretch } from './types';

export const tokens = {
    page: {
        padding: {
            mobile: 20,
            desktop: 40,
        },
    },
    brand: {
        height: {
            mobile: 28,
            desktop: 40,
        },
    },
    section: {
        gap: {
            [SectionGap.None]: 0,
            [SectionGap.Small]: 16,
            [SectionGap.Base]: 32,
            [SectionGap.Large]: 64,
        },
        maxWidth: {
            [SectionStretch.Small]: 460,
            [SectionStretch.Medium]: 768,
        },
    },
};
